
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.939 19.658l9.148 1.325V12.23H.94v7.428zm0-8.678h9.148V2.226L.94 3.551v7.43zm10.399 10.184l12.275 1.778V12.23H11.338v8.934zm0-19.12v8.936h12.275V.268L11.338 2.045z","fill":"#98A3B3"}})])
          )
        }
      }
    